import { FC } from "react";

import { Avatar } from "@livechat/design-system-react-components";

export enum UserSymbolSize {
  Small,
}

interface IProps {
  inactive?: boolean;
  name: string;
  size?: UserSymbolSize;
}

export const UserSymbol: FC<IProps> = ({ inactive, name, size }) => {
  return (
    <Avatar
      type="text"
      text={name}
      size={size === UserSymbolSize.Small ? "small" : "large"}
      css={{ opacity: inactive ? 0.5 : 1 }}
    />
  );
};
